import React from "react";

const PageHero = ({ title, image }) => {
  return (
    <section>
      {/* Title band */}
      <div className="bg-[#eef1f3]">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-14">
          <h1 className="text-4xl md:text-5xl font-bold brand-navy dash">{title}</h1>
        </div>
      </div>
      {/* Banner image */}
      <div
        className="h-[300px] md:h-[420px] bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      />
    </section>
  );
};

export default PageHero;
